export default "__VITE_ASSET__C$yidX6T__"